import type { ReviewAspect, ReviewSummary } from '../model/types';
import type { ApiReviewAspect, GetReviewSummaryApiResponse } from './getReviewSummary.types';

const adaptAspect = (aspect: ApiReviewAspect): ReviewAspect => ({
  key: aspect.key,
  name: aspect.name,
  summary: aspect.summary,
  mentionsCount: aspect.mentions_count,
});

export const getAdaptedReviewSummary = (responseData: GetReviewSummaryApiResponse): ReviewSummary | null => {
  const { result } = responseData;
  if (!result) return null;

  return {
    period: { from: result.period.from, to: result.period.to },
    reviewsTotal: result.reviews_total,
    hotelSummary: result.hotel_summary,
    praised: result.praised_aspects.map((aspect) => adaptAspect(aspect)),
    caveats: result.warnings_aspects.map((aspect) => adaptAspect(aspect)),
  };
};
